export function domainShowHref(domainId: string, pages: { issuesPage: number; pagesPage: number }) {
  const params = new URLSearchParams();
  if (pages.issuesPage > 1) params.set("issues_page", String(pages.issuesPage));
  if (pages.pagesPage > 1) params.set("pages_page", String(pages.pagesPage));

  const query = params.toString();
  return query ? `/domains/${domainId}?${query}` : `/domains/${domainId}`;
}
